import * as React from 'react';

export const Note = () => (
    <svg role="presentation" fill="none" xmlns="http://www.w3.org/2000/svg" height="96px" width="96px" viewBox="0 0 96 96">
        <line x1="37.5217" y1="40.7391" x2="59.5217" y2="40.7391" stroke="#566878" strokeWidth="2" strokeLinecap="round" />
        <line x1="37.5217" y1="44.913" x2="59.5217" y2="44.913" stroke="#566878" strokeWidth="2" strokeLinecap="round" />
        <line x1="37.5217" y1="49.087" x2="59.5217" y2="49.087" stroke="#566878" strokeWidth="2" strokeLinecap="round" />
        <line x1="37.5217" y1="53.2609" x2="59.5217" y2="53.2609" stroke="#566878" strokeWidth="2" strokeLinecap="round" />
        <line x1="37.5217" y1="57.4348" x2="59.5217" y2="57.4348" stroke="#566878" strokeWidth="2" strokeLinecap="round" />
        <line x1="37.5217" y1="61.6087" x2="59.5217" y2="61.6087" stroke="#566878" strokeWidth="2" strokeLinecap="round" />
        <line x1="37.5217" y1="65.7826" x2="54.3043" y2="65.7826" stroke="#566878" strokeWidth="2" strokeLinecap="round" />
        <path
            fill="#566878"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34.5527 29.2174C32.2013 29.2174 30.2609 31.1674 30.2609 33.5301V71.0786C30.2609 73.4414 32.2014 75.3913 34.5527 75.3913H61.7082C64.0595 75.3913 66 73.4414 66 71.0786V33.5301C66 31.1673 64.0595 29.2174 61.7082 29.2174H34.5527ZM61.5652 32.3478H34.4348C33.7308 32.3478 33.3242 32.8227 33.3242 33.5301V71.0786C33.3242 71.786 33.8487 72.3131 34.5527 72.3131H61.7082C62.4122 72.3131 62.9367 71.786 62.9367 71.0786V33.5301C62.9367 32.8227 62.2692 32.3478 61.5652 32.3478Z"
        />
    </svg>
);
